import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs } from '@mui/material';
import { change } from 'redux-form';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import NotificationForm from './NotificationForm';
import { updateNotification, viewNotification } from '../../Services/Utils/NotificationApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { getImage } from '../../Services/Utils/FileApis';
import { fromEpochToDate } from '../../Services/config/globals';

function EditNotification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  useEffect(() => {
    const data = {
      id: params.id
    };
    viewNotification(data).then((res) => {
      if (res.code === 2006 || res.view.isBroadcast === true) {
        navigate('/notifications');
        return false;
      }
      let service = {};
      service = {
        id: res.view.serviceProviderView.id,
        label: res.view.serviceProviderView.name,
        value: res.view.serviceProviderView.name,
        path: getImage(res.view.serviceProviderView.logoView)
      };
      dispatch(change('notificationForm', 'serviceProvider', service));
      dispatch(change('notificationForm', 'notificationDescription', res.view.description));
      dispatch(change('notificationForm', 'notificationLink', res.view.link));
      dispatch(change('notificationForm', 'location', res.view.location));
      dispatch(change('notificationForm', 'notificationEndDate', dayjs(new Date(res.view.endDate * 1000))));
    });
  }, []);
  const onButtonClick = (formData) => {
    const myDate = new Date(formData.notificationEndDate);
    const myEpoch = myDate.getTime() / 1000;
    const data = {
      id: params.id,
      serviceProviderView: formData.serviceProvider,
      description: formData.notificationDescription,
      link: formData.notificationLink,
      location: formData.location,
      endDate: fromEpochToDate(myEpoch)
    };
    updateNotification(data).then((res) => {
      if (res.hasError === false) {
        navigate('/notifications');
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div>
      <div className="container-fluid ">
        <div className="breadcrumb-menu-con">
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
          >
            <Link to="/notifications">Notifications</Link>
            <Link to="#">Edit Notification</Link>
          </Breadcrumbs>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div>
              <NotificationForm
                onButtonClick={onButtonClick}
                notificationText="Edit Notification"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditNotification;
